import { uploadImageSlider } from './store';
import { registerPostMediaApi } from './admin';

/**
 * Picture upload for Posts. Pictures only — video is deferred until it has its
 * own collection and something compresses it.
 *
 * Every upload is recorded in the post picture library, which is a separate
 * collection from the portal media library. That is what lets the editor offer
 * a "pick one you already uploaded" list, so the same screenshot is not
 * uploaded once per guide. It also keeps post pictures out of the background
 * gallery every operator sees, and out of their ten-per-kind allowance.
 */

const IMAGE_TYPES = ['image/webp', 'image/jpeg', 'image/png', 'image/gif'];

export async function uploadPostMedia(file: File): Promise<string> {
   if (IMAGE_TYPES.includes(file.type)) {
      const res = await uploadImageSlider(file);
      const url = (res as { data?: { imageUrl?: string } })?.data?.imageUrl;
      if (!url) throw new Error('That picture did not upload — please try again.');

      // Recording it is what puts it in the library. A failure here must not
      // lose the picture the author just placed, so it is not fatal.
      try {
         await registerPostMediaApi({
            url,
            name: file.name.replace(/\.[a-z0-9]+$/i, ''),
            size: file.size,
            contentType: file.type,
         });
      } catch {
         // Uploaded and usable, just missing from the library list.
      }

      return url;
   }

   if (file.type.startsWith('video/')) {
      throw new Error('Video in posts is not ready yet. Please use a picture for now.');
   }

   throw new Error('Only WebP, JPEG, PNG or GIF pictures can be added.');
}
